"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Storybook = exports.ModalSizes = exports.ModalOpenAnimationTime = exports.ModalCloseAnimationTime = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _IconButton = _interopRequireDefault(require("../../components/IconButton"));
var _Modal = require("../../components/Modal/Modal.styles");
var _ModalOverlay = require("../../components/Modal/ModalOverlay");
var _PortalBase = _interopRequireDefault(require("../../components/PortalBase"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _getOwnerDocument = _interopRequireDefault(require("../../utils/getOwnerDocument"));
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
var _isAnimation = require("../../utils/isAnimation");
var _omit = _interopRequireDefault(require("../../utils/omit"));
var _splitCommonFromProps15 = _interopRequireDefault(require("../../utils/splitCommonFromProps"));
var _excluded = ["height", "width", "zIndex"],
  _excluded2 = ["className", "children", "container", "dismissible", "dismissOnBlur", "disableCloseButton", "gradientBackground", "open", "overrides", "modalStyles", "overlayRef", "onClose", "size", "fullScreen", "rootHeight", "enforceOverflow", "trapFocus"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var ModalSizes = exports.ModalSizes = /*#__PURE__*/function (ModalSizes) {
  ModalSizes["small"] = "small";
  ModalSizes["medium"] = "medium";
  ModalSizes["large"] = "large";
  return ModalSizes;
}({});
var ModalOpenAnimationTime = exports.ModalOpenAnimationTime = 300; // in ms
var ModalCloseAnimationTime = exports.ModalCloseAnimationTime = 200; // in ms

var MODAL_LOCATOR = "IcfModal";
var getModalsCount = function getModalsCount() {
  return document.querySelectorAll("[data-ta-locator=\"".concat(MODAL_LOCATOR, "\"]")).length;
};
var ModalBox = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, props, {
    ref: ref
  }));
});
ModalBox.displayName = "ModalBox";
var Modal = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var parentDocument = (0, _getOwnerDocument.default)(typeof props.container === "string" ? document.querySelector(props.container) : props.container);
  var _splitCommonFromProps = (0, _splitCommonFromProps15.default)(props, _Modal.modalCommon),
    _splitCommonFromProps2 = _slicedToArray(_splitCommonFromProps, 2),
    _splitCommonFromProps3 = _splitCommonFromProps2[0],
    height = _splitCommonFromProps3.height,
    width = _splitCommonFromProps3.width,
    zIndex = _splitCommonFromProps3.zIndex,
    common = _objectWithoutProperties(_splitCommonFromProps3, _excluded),
    _splitCommonFromProps4 = _splitCommonFromProps2[1],
    className = _splitCommonFromProps4.className,
    children = _splitCommonFromProps4.children,
    _splitCommonFromProps5 = _splitCommonFromProps4.container,
    container = _splitCommonFromProps5 === void 0 ? parentDocument === null || parentDocument === void 0 ? void 0 : parentDocument.body : _splitCommonFromProps5,
    _splitCommonFromProps6 = _splitCommonFromProps4.dismissible,
    dismissible = _splitCommonFromProps6 === void 0 ? true : _splitCommonFromProps6,
    _splitCommonFromProps7 = _splitCommonFromProps4.dismissOnBlur,
    dismissOnBlur = _splitCommonFromProps7 === void 0 ? true : _splitCommonFromProps7,
    _splitCommonFromProps8 = _splitCommonFromProps4.disableCloseButton,
    disableCloseButton = _splitCommonFromProps8 === void 0 ? false : _splitCommonFromProps8,
    gradientBackground = _splitCommonFromProps4.gradientBackground,
    open = _splitCommonFromProps4.open,
    _splitCommonFromProps9 = _splitCommonFromProps4.overrides,
    overrides = _splitCommonFromProps9 === void 0 ? {} : _splitCommonFromProps9,
    modalStyles = _splitCommonFromProps4.modalStyles,
    _splitCommonFromProps10 = _splitCommonFromProps4.overlayRef,
    overlayRef = _splitCommonFromProps10 === void 0 ? null : _splitCommonFromProps10,
    onClose = _splitCommonFromProps4.onClose,
    _splitCommonFromProps11 = _splitCommonFromProps4.size,
    size = _splitCommonFromProps11 === void 0 ? ModalSizes.medium : _splitCommonFromProps11,
    _splitCommonFromProps12 = _splitCommonFromProps4.fullScreen,
    fullScreen = _splitCommonFromProps12 === void 0 ? false : _splitCommonFromProps12,
    rootHeight = _splitCommonFromProps4.rootHeight,
    _splitCommonFromProps13 = _splitCommonFromProps4.enforceOverflow,
    enforceOverflow = _splitCommonFromProps13 === void 0 ? true : _splitCommonFromProps13,
    _splitCommonFromProps14 = _splitCommonFromProps4.trapFocus,
    trapFocus = _splitCommonFromProps14 === void 0 ? true : _splitCommonFromProps14,
    otherProps = _objectWithoutProperties(_splitCommonFromProps4, _excluded2);
  var theme = (0, _reactJss.useTheme)();
  var classes = (0, _Modal.useModalStyles)(_objectSpread(_objectSpread({}, _Modal.modalVars.useVars(_objectSpread({
    width: width,
    height: height,
    zIndex: zIndex
  }, common))), _Modal.modalRootVars.useVars({
    rootHeight: rootHeight,
    defaultCloseButtonBackground: (0, _getRgbaFromHex.default)(theme.mode === "dark" ? theme.colors.baseShadow : theme.colors.baseContrast040, 0.4)
  })));
  var lockOverflowScrolling = function lockOverflowScrolling(shouldLock) {
    var body = window.document.body;
    var scrollOffset = window.innerWidth - window.document.body.clientWidth;
    if (shouldLock) {
      body.style.boxSizing = "border-box";
      body.style.overflow = "hidden";
    } else if (getModalsCount() <= 1) {
      body.style.boxSizing = "";
      body.style.overflow = "";
    }
    shouldLock && scrollOffset > 0 ? body.style.paddingRight = "".concat(scrollOffset, "px") : body.style.paddingRight = "";
  };
  (0, _react.useEffect)(function () {
    return function () {
      if (enforceOverflow && getModalsCount() < 1) {
        lockOverflowScrolling(false);
      }
    };
  }, [enforceOverflow]);
  var _useState = (0, _react.useState)({
      isExited: true,
      isVisible: false,
      prevOpen: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  if (open !== state.prevOpen) {
    if (open) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          prevOpen: open,
          isVisible: true
        });
      });
    } else {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          prevOpen: open,
          isExited: true
        });
      });
    }
  }
  var focusRef = props.modalRef ? props.modalRef : /*#__PURE__*/(0, _react.createRef)();
  var animationHandler = function animationHandler(event) {
    if (event.type === "animationend") {
      if ((0, _isAnimation.isAnyAnimation)(event, ["ModalClose", "DrawerClose", "DrawerCloseGentle", "DropDownClose"])) {
        handleClose();
      }
      if ((0, _isAnimation.isAnimation)(event, "Open") && props.onOpen) {
        props.onOpen();
      }
    }
    if (event.type === "animationstart") {
      if ((0, _isAnimation.isAnyAnimation)(event, ["ModalOpen", "DrawerOpen", "DropDownOpen"])) {
        handleOpen();
      }
    }
  };
  var handleOpen = function handleOpen() {
    parentDocument.addEventListener("focus", focusHandler);
    enforceOverflow && lockOverflowScrolling(true);
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isVisible: true
      });
    });
    if (focusRef.current !== null) {
      focusRef.current.scrollTop = 0;
      focusRef.current.focus();
    }
  };
  var handleClose = function handleClose() {
    parentDocument.removeEventListener("focus", focusHandler);
    enforceOverflow && lockOverflowScrolling(false);
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isVisible: false
      });
    });
    if (focusRef.current !== null) {
      focusRef.current.blur();
    }
    if (props.cleanup) {
      props.cleanup();
    }
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isExited: true
      });
    });
  };
  var handleClick = function handleClick(event) {
    props.onClick(event);
  };
  var keyCloseHandler = function keyCloseHandler(event) {
    if (event.key === "Escape" && state.isVisible && props.dismissible) {
      event.stopPropagation();
      props.onClose(event);
    }
  };
  var focusHandler = function focusHandler() {
    if (!trapFocus) {
      return undefined;
    }
    if (focusRef.current) {
      var currentActiveElement = parentDocument.activeElement;
      if (!focusRef.current.contains(currentActiveElement)) {
        focusRef.current.focus();
      }
    }
  };
  var nullRender = Boolean(!state.isVisible && state.isExited && !open);
  var iconButtonClasses = (0, _classnames.default)(classes.defaultCloseButtonStyles, overrides.closeButton);
  var modalRootClasses = (0, _classnames.default)(classes.rootVariables, classes.defaultModalRootStyles, overrides.modalRoot, className);
  var modalOverlayClasses = (0, _classnames.default)(classes.defaultModalOverlayStyles, overrides.modalOverlay, _defineProperty({}, classes.modalOverlayOpen, open));
  var modalBoxClasses = (0, _classnames.default)(classes.variables, classes.defaultModalBoxStyles, _defineProperty({}, classes.gradient, gradientBackground && theme.mode === "dark"), _defineProperty({}, classes.small, size === ModalSizes.small && !fullScreen), _defineProperty({}, classes.medium, size === ModalSizes.medium && !fullScreen), _defineProperty({}, classes.large, size === ModalSizes.large && !fullScreen), _defineProperty({}, classes.fullScreen, fullScreen), overrides.modalBox, _defineProperty({}, classes.modalOpen, open && !overrides.modalOpen), _defineProperty({}, classes.modalClose, !open && state.isVisible && !overrides.modalClose), _defineProperty({}, overrides.modalOpen, open && overrides.modalOpen), _defineProperty({}, overrides.modalClose, !open && overrides.modalClose));
  var filteredOtherProps = (0, _omit.default)(["onOpen", "onClick", "cleanup", "modalRef", "render"], otherProps);
  return !nullRender && /*#__PURE__*/_react.default.createElement(_PortalBase.default, {
    container: container
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: ref,
    className: modalRootClasses
  }, filteredOtherProps), /*#__PURE__*/_react.default.createElement(ModalBox, {
    style: !nullRender && modalStyles ? modalStyles : undefined,
    className: modalBoxClasses,
    tabIndex: -1,
    ref: focusRef,
    onClick: props.onClick ? handleClick : undefined,
    onKeyDown: keyCloseHandler,
    onAnimationStart: animationHandler,
    onAnimationEnd: animationHandler,
    "data-ta-locator": MODAL_LOCATOR
  }, !disableCloseButton && dismissible && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: onClose,
    name: "close",
    className: iconButtonClasses,
    "data-ta-locator": "ModalCloseButton"
  }), typeof props.render === "function" ? props.render() : children), /*#__PURE__*/_react.default.createElement(_ModalOverlay.ModalOverlay, {
    className: modalOverlayClasses,
    onClick: function onClick(event) {
      if (dismissible && dismissOnBlur) {
        onClose(event);
      }
    },
    "aria-hidden": "true",
    ref: overlayRef
  })));
});
Modal.displayName = "Modal";
var Storybook = exports.Storybook = Modal;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/overlay-modal--docs
 */
var exportedComponent = (0, _defaultProps.default)(Modal);
exportedComponent.displayName = "Modal";
var _default = exports.default = exportedComponent;